module.exports = __webpack_public_path__ + "static/media/survey.4563c26f.svg";